import React, { Component } from "react";
import { GridRow, GridColumn, LazyImg } from "arv-reactcomponents";
import { FOOTER } from "npmlinks-constants";
import LazyLoad from 'react-lazyload';

const {
  TRADEMARK: { TEXT, LOGO },
} = FOOTER;
class TradeMark extends Component {
  componentDidMount() {
    console.log(this);
  }
  render() {
    return (
      <GridRow className="wc-footertrademark">
        <GridColumn className="wc-footertrademark-col">
          <span className="wc-footertrademark-text">{TEXT}</span>
          <LazyLoad>
            <LazyImg
              className="wc-footertrademark-logo"
              src={LOGO}
              rootMargin="1500px"
              onWinLoad
            />
          </LazyLoad>
        </GridColumn>
      </GridRow>
    );
  }
}

export default TradeMark;
